document.documentElement.classList.remove('no-js');

const drawer = document.querySelector('#CartDrawer');
const overlay = document.querySelector('.drawer-overlay');
const bagButton = document.querySelector('.bag-button');
const closeButtons = document.querySelectorAll('[data-cart-close]');
const menuButton = document.querySelector('.menu-toggle');
const mobileMenu = document.querySelector('#MobileMenu');

function openCart() {
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.hidden = false;
  document.body.classList.add('drawer-open');
}

function closeCart() {
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  overlay.hidden = true;
  document.body.classList.remove('drawer-open');
}

bagButton?.addEventListener('click', openCart);
closeButtons.forEach((button) => button.addEventListener('click', closeCart));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

menuButton?.addEventListener('click', () => {
  const expanded = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!expanded));
  mobileMenu.hidden = expanded;
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const addButton = form.querySelector('.primary-add');
  const availability = document.querySelector('.availability');
  const groups = [...form.querySelectorAll('[data-option-group]')];
  const variantsNode = form.querySelector('[data-product-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];

  const selectedValues = () => groups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue);

  function updateOptionAvailability() {
    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        const possible = variants.some((variant) => variant.available && variant.options[groupIndex] === button.dataset.optionValue);
        button.disabled = !possible;
      });
    });
  }

  function updateVariant(preferredIndex, preferredValue) {
    const current = selectedValues();
    let variant = variants.find((item) => item.options.every((value, index) => value === current[index]));
    if (!variant && preferredIndex !== undefined) variant = variants.find((item) => item.available && item.options[preferredIndex] === preferredValue);
    if (!variant || !select) return;
    groups.forEach((optionGroup, optionIndex) => {
      optionGroup.querySelectorAll('[data-option-value]').forEach((item) => {
        const selected = item.dataset.optionValue === variant.options[optionIndex];
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
    });
    select.value = String(variant.id);
    select.dispatchEvent(new Event('change', { bubbles: true }));
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }
    if (availability) {
      availability.lastChild.textContent = variant.available ? 'In stock and ready to order' : 'Currently unavailable';
      availability.classList.toggle('is-unavailable', !variant.available);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    const featuredImage = variant.featured_image || variant.featured_media?.preview_image;
    const mainMedia = document.querySelector('[data-main-product-media]');
    const mainImage = mainMedia?.querySelector('img');
    if (featuredImage?.src && mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.src = featuredImage.src;
      mainMedia.dataset.zoomSrc = featuredImage.src;
    }
    updateOptionAvailability();
  }

  groups.forEach((group) => {
    group.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        group.querySelectorAll('[data-option-value]').forEach((item) => {
          item.classList.toggle('is-selected', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
        updateVariant(Number(group.dataset.optionIndex), button.dataset.optionValue);
      });
    });
  });

  select?.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    document.querySelectorAll('[data-mobile-price]').forEach((node) => { node.textContent = option?.dataset.price || ''; });
  });
  updateOptionAvailability();
});

document.querySelector('[data-mobile-add]')?.addEventListener('click', () => {
  document.querySelector('[data-product-form]')?.requestSubmit();
});

const quantityInput = document.querySelector('.quantity-selector input');
document.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
  if (!quantityInput) return;
  quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
});
document.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
  if (!quantityInput) return;
  quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
});

document.querySelector('[data-share-product]')?.addEventListener('click', async () => {
  const status = document.querySelector('[data-share-status]');
  try {
    if (navigator.share) {
      await navigator.share({ title: document.title, url: window.location.href });
    } else {
      await navigator.clipboard.writeText(window.location.href);
      if (status) status.textContent = 'Link copied.';
    }
  } catch (error) {
    if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the link from your browser.';
  }
});

const zoomDialog = document.querySelector('#ProductZoom');
const zoomImage = zoomDialog?.querySelector('[data-zoom-image]');
document.querySelectorAll('[data-product-zoom]').forEach((button) => {
  button.addEventListener('click', () => {
    if (!zoomDialog || !zoomImage) return;
    zoomImage.src = button.dataset.zoomSrc;
    zoomImage.alt = button.dataset.zoomAlt || '';
    zoomDialog.showModal();
  });
});
zoomDialog?.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
zoomDialog?.addEventListener('click', (event) => { if (event.target === zoomDialog) zoomDialog.close(); });

document.querySelectorAll('[data-quick-add]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    const original = button.innerHTML;
    button.textContent = 'Adding…';
    try {
      await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      document.querySelectorAll('[data-cart-heading-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
      document.querySelectorAll('[data-cart-total]').forEach((node) => { node.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: cart.currency }).format(cart.total_price / 100); });
      openCart();
      window.setTimeout(() => window.location.reload(), 450);
    } catch (error) {
      button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => { button.disabled = false; button.innerHTML = original; }, 1000);
    }
  });
});
